//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from '../../api';

export default {

        beforeRouteEnter: (to, from, next) => {
            next((vm) => {
            });
        },
        components: {
        },
        mounted() {
            this.id = this.$route.query.id; // 招标单id
            this.orgcode = this.$route.query.code;
            this.loadUpperBid();
            this.getTenderDetail();
        },
        activated() {
        },
        data() {
            return {
                id: '',
                orgcode: '',
                inviteStage: {},
                lower: {},
                roundsStage: [],
                signup: {},
                tender: {},
                tenderDetail: {},
                nowDate: new Date(),
            };
        },
        computed: {
            addrListById() {
                return this.$store.state.addrListById;
            },
        },
        methods: {
            pastTime(time = '') {
                let diff = 0;
                const end = new Date(time.replace(/-/g, '/'));
                diff = end.getTime() - this.nowDate.getTime();
                if (diff <= 0) {
                    return false;
                } else if (diff > 0) {
                    return true;
                }
            },
            nowStateTop(state) { // 状态机
                let t = '待审核';
                switch (state) {
                    case 20:
                        t = 0;
                        break;
                    case 30:
                        t = 2;
                        break;
                    case 40:
                        t = 2;
                        break;
                    case 50:
                        t = 3;
                        break;
                    case 60:
                        t = 3;
                        break;
                    case 70:
                        t = 4;
                        break;
                    case 80:
                        t = 4;
                        break;
                    case 90:
                        t = 5;
                        break;
                    case 100:
                        t = 0;
                        break;
                    case 110:
                        t = 0;
                        break;
                    default:
                        t = 1;
                        break;
                }
                return t;
            },
            getTenderDetail() {
                api.vega.tender.detail({
                    tenderId: this.id,
                }).then((res) => {
                    const data = res.data.data;
                    this.tenderDetail = data;
                });
            },
            rounds(rounds) {
                let t = '一';
                switch (rounds) {
                    case 2:
                        t = '二';
                        break;
                    case 3:
                        t = '三';
                        break;
                    default:
                        t = '一';
                        break;
                }
                return t;
            },
            loadUpperBid() {
                api.vega.tender.upperBidDetail({
                    tenderId: this.id,
                    orgcode: this.orgcode,
                }).then((res) => {
                    const { inviteStage, lower, roundsStage, signup, tender } = res.data.data;
                    this.inviteStage = inviteStage;
                    this.lower = lower;
                    this.roundsStage = roundsStage;
                    this.signup = signup;
                    this.tender = tender;
                });
            },
            nowStateUp(state, rounds) { // 状态机
                let t = '待审核';
                let r = '第一轮';
                switch (state) {
                    case 20:
                        t = '审核不通过';
                        break;
                    case 30:
                        t = '报名中';
                        break;
                    case 40:
                        t = '待邀标';
                        break;
                    case 50:
                        t = '应标中';
                        break;
                    case 60:
                        t = '待招标';
                        break;
                    case 70:
                        t = '投标中';
                        break;
                    case 80:
                        t = '开标中';
                        break;
                    case 90:
                        t = '已完成';
                        break;
                    case 100:
                        t = '已关闭';
                        break;
                    case 110:
                        t = '已取消';
                        break;
                    default:
                        t = '待审核';
                        break;
                }
                switch (rounds) {
                    case 2:
                        r = '第二轮报价';
                        break;
                    case 3:
                        r = '第三轮报价';
                        break;
                    default:
                        r = '第一轮报价';
                        break;
                }
                return {
                    t,
                    r,
                };
            },
            nowStateLow(state, rounds, stage) { // 状态机
                let r = '第一轮报价';
                let t = '已报名待审核';
                switch (rounds) {
                    case 2:
                        r = '第二轮报价';
                        break;
                    case 3:
                        r = '第三轮报价';
                        break;
                    default:
                        r = '第一轮报价';
                        break;
                }
                if (stage === 10) { // 报名阶段
                    switch (state) {
                        case 3:
                            t = '已报名待审核';
                            break;
                        case 5:
                            t = '报名未通过';
                            break;
                        case 8:
                            t = '已关闭';
                            break;
                        default:
                            t = '已报名待审核';
                            break;
                    }
                } else if (stage === 20) { // 邀标应标阶段
                    switch (state) {
                        case 1:
                            t = '待应标';
                            break;
                        case 2:
                            t = '未应标';
                            break;
                        case 3:
                            t = '已应标待审核';
                            break;
                        case 5:
                            t = '应标未通过';
                            break;
                        case 8:
                            t = '已关闭';
                            break;
                        default:
                            t = '待应标';
                            break;
                    }
                } else if (stage === 30) { // 投标阶段
                    switch (state) {
                        case 1:
                            t = '待投标';
                            break;
                        case 2:
                            t = '未投标';
                            break;
                        case 3:
                            t = '已投标待审核';
                            break;
                        case 5:
                            t = '未中标';
                            break;
                        case 6:
                            t = '已中标';
                            break;
                        case 7:
                            t = '未中标';
                            break;
                        default:
                            t = '待投标';
                            break;
                    }
                }
                return {
                    r,
                    t,
                };
            },
            findCity(p, c) {
                let addr = '';
                const addrList = this.addrListById;
                const _addrList = JSON.stringify(addrList);
                if (_addrList !== '{}') {
                    addr = `${p ? addrList[p].content : ''}${p && c ? '·' : ''}${c && addrList ? addrList[c].content : ''}`;
                }
                return addr;
            },
            download(url) {
                if (url !== '') {
                    const newTab = window.open('about:blank');
                    newTab.location.href = url;
                }
            },
        },
    };
